export default "__VITE_ASSET__BftyOrfT__"